import { RouterManager } from '@aclass/admin/managers';
import { SmsTemplateStory } from '@aclass/admin/storage/actions';
import { IAdminState, ISmsTemplateModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class SmsTemplateEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:sms-template-edit';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ISmsTemplateModuleState['editPageRecordId']>(['smsTemplateModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(SmsTemplateEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        const id = parseInt(route.params.id);
        this.id = id;
        this.ngRdx.dispatch(SmsTemplateStory.dryRunEditPage({ id }));
    }
}
